import { render } from "./ConsentForm.vue?vue&type=template&id=63479756&scoped=true"
import script from "./ConsentForm.vue?vue&type=script&lang=js"
export * from "./ConsentForm.vue?vue&type=script&lang=js"

import "./ConsentForm.vue?vue&type=style&index=0&id=63479756&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63479756"]])

export default __exports__